import { Config } from '@leverege/plugin'
import { Toast } from '@leverege/ui-elements'

export default {
  id : 'ps.action.CopyEventEndVideoUrl',
  matches : {
    client : 'LinearViewBlock'
  },
  layout : {
    group : [ 'Video', 'End' ],
    groupIcons : [ 'fa fa-fw fa-video-camera' ]
  },
  appearance : () => ( {
    name : 'Copy',
    icon : 'fa fa-fw fa-copy'
  } ),
  handles : ( context ) => {
    const { item } = context
    
    return item?.stopData != null
  },
  perform : ( { context } ) => {
    const { item } = context
    const videoBucketUrl = Config.get( 'LinearViewBlock', 'gcsVideoBucketUrl' )
    navigator.clipboard.writeText( `${videoBucketUrl}/${item.stopData.videoPath}` )
    Toast.success( 'Copied to clipboard!' )
  }
}
